export enum ReservationSource {
  BN_ADMIN = 'admin',
  BN_APP = 'app',
  BN_WEBSITE = 'website',
  CHANNEL_MANAGER = 'channel-manager'
}
